export default __webpack_public_path__ + "static/media/gotmy-placeholder-3.57bff14c.jpeg";